import { jsx as _jsx } from "react/jsx-runtime";
import { hydrateRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import './index.css';
import { routes } from './routes';
const router = createBrowserRouter(routes, {
    hydrationData: window.__staticRouterHydrationData
});
const rootElement = document.getElementById('root');
if (rootElement) {
    hydrateRoot(rootElement, /*#__PURE__*/ _jsx(RouterProvider, {
        router: router
    }));
}
